import Vue from 'vue'
import {NOTIFICA_ERRORE, NOTIFICA_SUCCESSO} from '../../costanti'

export default {
    namespaced: true,
    state: {
        segnalazioneSelezionata: null,
        storiaSegnalazioneSelezionata: [],
        // nuovi dati della segnalazione
        nuoviDati: null
    },
    mutations: {
        // == Segnalazione selezionata ==
        SET_SEGNALAZIONE_SELEZIONATA: (state: any, segnalazione: any) => (state.segnalazioneSelezionata = segnalazione),
        SET_STORIA_SEGNALAZIONE_SELEZIONATA: (state: any, eventi: any) => (state.storiaSegnalazioneSelezionata = eventi),
        // nuovi dati della segnalazione
        SET_NUOVI_DATI: (state: any, nuoviDati: object) => (state.nuoviDati = nuoviDati)
    },
    actions: {
        async cambiaRilevamentoMostrato({commit, rootState}: any, id: number) {
            // toglie il precedente
            commit('SET_RILEVAMENTO_MOSTRATO', null)
            // troviamo il rilevamento
            try {
                const response = await Vue.axios.get(`/api_report/segnalazioni.json?id=${id}`)
                const rilevamento = response.data[0]
                commit('SET_RILEVAMENTO_MOSTRATO', rilevamento)
            } catch (err) {
                console.error(err)
            }
        },
        async caricaStoriaSegnalazione({commit}: any, idSegnalazione: number) {
            try {
                const response = await Vue.axios.get(`/api_report/eventi_modifica_segnalazioni.json?segnalazione=${idSegnalazione}`)
                commit('SET_STORIA_SEGNALAZIONE_SELEZIONATA', response.data)
            } catch (err) {
                console.error(err)
            }
        },
        async modificaSegnalazione({commit, dispatch, rootState}: any, {id, segnalazione, note_modifica}: any) {
            // aggiorniamo la segnalazione
            try {
                const response = await Vue.axios.patch(`/api_report/segnalazioni/${id}/`, {
                    ...segnalazione,
                    note_modifica
                })
                // carichiamo le segnalazioni
                dispatch('reportMappa/caricaSegnalazioni', {light: false}, {root: true})
                // mostriamo una notifica di successo
                dispatch('modal/showNotification', {
                    name: NOTIFICA_SUCCESSO,
                    title: 'Segnalazione modificata'
                }, {root: true})
            } catch (err) {
                console.error(err)
                // mostriamo una notifica di errore
                dispatch('modal/showNotification', {
                    name: NOTIFICA_ERRORE,
                    title: `Errore durante la modifica`
                }, {root: true})
            }
        },
        async salvaSegnalazione({commit, dispatch, rootState}: any, segnalazione: any) {
            // aggiorniamo la segnalazione
            try {
                const response = await Vue.axios.post(`/api_report/segnalazioni/`, segnalazione)
                // carichiamo le segnalazioni
                dispatch('reportMappa/caricaSegnalazioni', {light: true}, {root: true})
                // mostriamo una notifica di successo
                dispatch('modal/showNotification', {
                    name: NOTIFICA_SUCCESSO,
                    title: 'Segnalazione caricata'
                }, {root: true})
                // chiudiamo il modal
                dispatch('modal/showModal', null, {root: true})
            } catch (err) {
                console.error(err)
                // mostriamo una notifica di errore
                dispatch('modal/showNotification', {
                    name: NOTIFICA_ERRORE,
                    title: `Errore durante il caricamento della segnalazione`
                }, {root: true})
            }
        }
    }
}
